import React from 'react';
import styles from './Image.module.scss';
import { SwiperSlide } from 'swiper/react';
import SwiperCustom from '../../../SwiperCustom/SwiperCustom';
import { ModalProvider } from '../../../Modal/modalContext';
import ProductButton from '../../../ProductModal/ProductButton';
import LightBoxButton from '../../../LightBox/LightBoxButton';
import { LightBoxProvider } from '../../../LightBox/LightBoxContext';
import { addCustomPathToLink, generateKey, sanitizeType } from 'functions';

const ImageSlider = ({ api, type, animationData, slidesPerView = 1, breakpoints = {} }) => {
  return (
    <SwiperCustom
      data-aos={animationData?.animation}
      data-aos-delay={animationData?.animationDelay}
      data-aos-duration={animationData?.animationDuration}
      data-aos-easing={animationData?.animationEasing}
      data-aos-anchor-placement={animationData?.animationAnchor}
      type={type}
      slidesPerView={slidesPerView}
      breakpoints={breakpoints}
    >
      {api.attributes.images.map((image, index) => (
        <SwiperSlide className={`${styles.SwiperSlide} ${type?.includes('photoFitContent') ? styles.photoFitContent : ''}`} key={generateKey()}>
          {!!image?.description && <p>{image.description}</p>}
          <figure
            className={`${styles.imageBox} ${sanitizeType(type, styles)} ${api.attributes.images.length === 2 ? styles[`imageBox${index}`] : ''}`}
            key={image.id}
          >
            <img className={styles.image} src={addCustomPathToLink(image.src, true)} alt={image.alt} />
            <LightBoxProvider>
              <LightBoxButton image={image} />
            </LightBoxProvider>
          </figure>
          {image?.imagePointsCoordinates &&
            image.imagePointsCoordinates.map((point) => (
              <ModalProvider key={generateKey()}>
                <ProductButton point={point} />
              </ModalProvider>
            ))}
          {!!image?.imagePointsYellow &&
            image.imagePointsYellow.map((point) => (
              <ModalProvider key={generateKey()}>
                <ProductButton point={point} />
              </ModalProvider>
            ))}
        </SwiperSlide>
      ))}
    </SwiperCustom>
  );
};
export default ImageSlider;
